import formatMoney from "../helpers/formatMoney";
import { ID, Part } from "../types";

interface PartPriceProps {
  price: number | null;
  discount: string | number | null;
  thePackage?: Part | undefined;
  mainClass?: string;
  packagedClass?: string;
  discountClass?: string;
  fullClass?: string;
}

const PartPrice: React.FC<PartPriceProps> = ({
  thePackage,
  price,
  discount,
  mainClass = "part-price",
  packagedClass = "part-price",
  discountClass = "part-price-discount",
  fullClass = "part-price-full",
}) => {
  if (thePackage) {
    return (
      <span className={packagedClass}>Included in {thePackage.label}</span>
    );
  } else {
    if (discount) {
      return (
        <span className={mainClass}>
          <span className={discountClass}>{formatMoney(discount)}</span>
          <span className={fullClass}>{formatMoney(price)}</span>
        </span>
      );
    } else {
      return price !== null ? (
        <span className={mainClass}>{formatMoney(price)}</span>
      ) : null;
    }
  }
};

export default PartPrice;
